import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Recipes = ApplicationRecord.extend({
  attrs: {
    title: attr(),
    image_url: attr(),
    principal_rating: attr(),
    latest_delivery_date: attr(),
    principal_feedback_id: attr(),
    recipe_id: attr(),
    latest_delivery_id: attr(),
  },
  static: {
    endpoint: '/recipes',
    jsonapiType: 'customers-recipes',
  },
});

export default Recipes;
